import React, { useState } from "react";
import { TiDelete } from "react-icons/ti";
import { useDispatch, useSelector } from "react-redux";
import { assignBots } from "store/teamLead/teamLeadThunk"; // Import the unassignBot action
import { unassignWorker } from "store/worker/workerThunk";

const AgentDetails = ({ toggleModal, agentData, workers }) => {
  const dispatch = useDispatch();
  const { unAssignedBots = [] } = useSelector((state) => state.worker) || {};
  const [unAssignedBotsData, setUnAssignedBotsData] = useState(unAssignedBots);
  const [selectedBot, setSelectedBot] = useState("");
  const [activeTab, setActiveTab] = useState("overview");
  const [, setUnassignedBots] = useState(unAssignedBots);

  const assignedWorkers = (workers || []).filter(
    (worker) => worker.assigned_to_agent === agentData.Id
  );

  const [assignedBots, setAssignedBots] = useState(assignedWorkers || []);

  const handleAssignBot = () => {
    if (selectedBot) {
      const bot = unAssignedBots?.find((b) => b.id === parseInt(selectedBot));
      if (bot && !assignedBots?.find((b) => b.id === bot.id)) {
        dispatch(
          assignBots({
            worker_id: selectedBot,
            user_id: agentData.Id,
          })
        ).then(() => {
          setAssignedBots((prevAssignedBots) => [...prevAssignedBots, bot]);
          setUnassignedBots((prevUnassignedBots) =>
            prevUnassignedBots.filter((b) => b.id !== bot.id)
          );
        });
      }
      setSelectedBot("");
    }
  };

  const handleUnassignBot = (id) => {
    // Dispatch the unassignBot action to update the backend
    dispatch(unassignWorker({ worker_id: id }))
      .then(() => {
        // Update the local state to remove the unassigned bot
        setAssignedBots((prevAssignedBots) =>
          prevAssignedBots.filter((bot) => bot.id !== id)
        );

        // Add the unassigned bot back to the unassigned bots list
        const unassignedBot = assignedBots.find((bot) => bot.id === id);
        if (unassignedBot) {
          setUnassignedBots((prevUnassignedBots) => [
            ...prevUnassignedBots,
            unassignedBot,
          ]);
        }
      })
      .catch((error) => {
        console.error("Failed to unassign bot:", error);
      });
  };

  return (
    <div className="modal_overlay">
      <div className="modal_container ">
        <div className="modal-header w-[95%] mx-auto">
          <h2 className="modal-title">Agent Details</h2>
          <div className="flex justify-end items-end">
            <button onClick={toggleModal}>
              <TiDelete size={26} className="text-red-400 hover:text-red-600" />
            </button>
          </div>
        </div>

        <div className="p-7">
          <div className="flex items-center mb-6 ">
            <div>
              <h2 className="text-xl font-semibold">
                {agentData?.first_name} {agentData?.last_name}
              </h2>
              <p className="text-gray-500">{agentData?.Email}</p>
            </div>
          </div>

          {/* Tabs */}
          <div className="flex justify-center border-b border-gray-300 space-x-8 mb-6">
            <button
              className={`px-4 py-2 text-sm font-semibold focus:outline-none ${
                activeTab === "overview"
                  ? "border-b-2 border-blue-500 text-blue-500"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveTab("overview")}
            >
              Overview
            </button>
            <button
              className={`px-4 py-2 text-sm font-semibold focus:outline-none ${
                activeTab === "bots"
                  ? "border-b-2 border-blue-500 text-blue-500"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveTab("bots")}
            >
              Bots
            </button>
          </div>

          {/* Tab Content */}
          <div className="mt-4">
            {activeTab === "overview" && (
              <div>
                <h3 className="text-lg font-semibold mb-4">Overview</h3>
                {/* Assigned Bots Tab */}
                <div>
                  <h4 className="text-md font-semibold text-green-600 mb-2">
                    Bots
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {assignedBots?.length > 0 ? (
                      assignedBots?.map((bot) => (
                        <div
                          key={bot.id}
                          className="relative flex items-center px-4 py-2 bg-green-100 text-green-600 rounded-full shadow-md text-sm"
                        >
                          {bot.name}
                          <button
                            onClick={() => handleUnassignBot(bot.id)} // Use bot.id here
                            className="absolute right-0 top-0 px-1 text-red-600 hover:text-red-700 text-lg"
                          >
                            ×
                          </button>
                        </div>
                      ))
                    ) : (
                      <p className="text-gray-500">No bots assigned yet.</p>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* Assign Bots Tab */}
            {activeTab === "bots" && (
              <div>
                <h3 className="text-lg font-semibold mb-4"> Bots</h3>
                <div className="mb-6">
                  <div className="flex flex-wrap gap-2">
                    {assignedBots?.length > 0 ? (
                      assignedBots?.map((bot, index) => (
                        <div
                          key={index}
                          className="relative flex items-center px-4 py-2 bg-green-100 text-green-600 rounded-full shadow-md text-sm"
                        >
                          {bot.name}
                          <button
                            onClick={() => handleUnassignBot(bot.id)} // Use bot.id here
                            className="absolute right-0 top-0 px-1 text-red-600 hover:text-red-700 text-lg"
                          >
                            ×
                          </button>
                        </div>
                      ))
                    ) : (
                      <p className="text-gray-500">No bots assigned yet.</p>
                    )}
                  </div>
                </div>
                <div>
                  <select
                    className="border border-gray-300 rounded-lg px-4 py-2 w-full"
                    value={selectedBot}
                    onChange={(e) => setSelectedBot(e.target.value)}
                  >
                    <option value="">Select a bot</option>
                    {Array.isArray(unAssignedBots) ? (
                      unAssignedBots.map((bot) => (
                        <option key={bot.id} value={bot.id}>
                          {bot.name}
                        </option>
                      ))
                    ) : (
                      <option disabled>No unassigned bots available</option>
                    )}
                  </select>
                  <button
                    onClick={handleAssignBot}
                    className="mt-2 w-full px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                  >
                    Assign Bot
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentDetails;
